import { createDirectus, rest, staticToken } from '@directus/sdk';

// Create directus client with appropriate configuration
const directus = createDirectus(process.env.NEXT_PUBLIC_DIRECTUS_URL!)
  .with(rest({
    onRequest: (options) => {
      // Add cache headers based on environment
      if (process.env.ENVIRONMENT !== 'development') {
        return {
          ...options,
          headers: {
            ...options.headers,
            // Use same cache strategy as defined in cache.config.ts
            'Cache-Control': 'public, s-maxage=43200, stale-while-revalidate=3600',
          }
        };
      } else {
        // In development, add no-cache headers to ensure fresh data
        return {
          ...options,
          headers: {
            ...options.headers,
            'Cache-Control': 'no-store, must-revalidate, max-age=0',
          }
        };
      }
    }
  }))
  .with(staticToken(process.env.NEXT_DIRECTUS_ADMIN_TOKEN!));

export default directus;
export const getDirectusClient = () => directus;


export const getReadableImageUrl = (imageId: string, filename: string) => {
  return `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${imageId}/${filename}`;
};

export const getIconUrl = (iconId: string) => {
    return `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${iconId}`;
  };

// Helper function for making cached requests
// Note: The actual caching is handled by the request interceptor above
// This function is provided for future extensibility and consistency
export const cachedRequest = async <T>(
  requestFn: () => Promise<T>
): Promise<T> => {
  // The cache headers are automatically added by the rest client configuration
  return requestFn();
};

